import { SpeciLine } from '@shared/components/speci/speci-types'

type SpeciBaleMinMax = {
  min?: number
  max?: number
}

type SpeciDuplicatedBales = {
  duplicates?: number[]
}

type SpeciSkippedBales = {
  skipped?: number[]
}

export type SpeciLinesInformation =
  | (SpeciBaleMinMax & SpeciDuplicatedBales & SpeciSkippedBales)
  | null

const getMinMaxValues = (sortedBaleNumbers: number[]): SpeciBaleMinMax | null => {
  if (sortedBaleNumbers.length === 0) return null

  return {
    min: sortedBaleNumbers[0],
    max: sortedBaleNumbers[sortedBaleNumbers.length - 1],
  }
}

const findDuplicates = (numbers: number[]): number[] => {
  const seen: Set<number> = new Set<number>()
  const uniqueDuplicates: Set<number> = new Set<number>()

  for (const number of numbers) {
    if (seen.has(number)) {
      uniqueDuplicates.add(number)
    } else {
      seen.add(number)
    }
  }

  return Array.from(uniqueDuplicates)
}

const findSkipped = (minMax: SpeciBaleMinMax | null, numbers: number[]): number[] => {
  const skipped: number[] = []
  const numbersSet: Set<number> = new Set<number>(numbers)

  if (minMax && minMax.min && minMax.max) {
    for (let i = minMax.min; i <= minMax.max; i += 1) {
      if (!numbersSet.has(i)) {
        skipped.push(i)
      }
    }
  }

  return skipped
}

export function getSpeciLineInformation(speciLines: SpeciLine[]): SpeciLinesInformation {
  if (!speciLines.length) return null

  // Get all bale numbers from all speci lines, flatten and sort the array
  const baleNumbers = speciLines
    .map((line) => line.baleNumbers)
    .flat()
    .sort((a, b) => a - b)

  const minMax = getMinMaxValues(baleNumbers)
  const duplicates = findDuplicates(baleNumbers)
  const skipped = findSkipped(minMax, baleNumbers)

  return {
    ...minMax,
    duplicates: duplicates.length ? duplicates : undefined,
    skipped: skipped.length ? skipped : undefined,
  }
}
